import { FieldUpdateHandlerParam } from 'shared/form';
import { useFieldCreateNewNetwork } from './useFieldCreateNewNetwork';
// eslint-disable-next-line import/prefer-default-export
export function useMediaGatewayFieldCreateNew(
  handleFieldUpdate: (param: FieldUpdateHandlerParam) => void,
): [(param: FieldUpdateHandlerParam) => void] {
  const [handleFieldNetwork] = useFieldCreateNewNetwork(handleFieldUpdate);
  const handleFieldCreateNew: (param: FieldUpdateHandlerParam) => void = (param) => {
    const { name } = param;

    if (name === 'ownnetid') {
        handleFieldNetwork(param);
    }
  };

  return [handleFieldCreateNew];
}
